import { render, staticRenderFns } from "./EndorsementList.vue?vue&type=template&id=0e76db9d&"
import script from "./EndorsementList.vue?vue&type=script&lang=js&"
export * from "./EndorsementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports